var map = {
	"./api_key.png": "d332",
	"./aws.png": "0e70",
	"./azure.png": "d8b8",
	"./azureBlob.png": "2020",
	"./azureLake.png": "f8d6",
	"./azurelogo.png": "0be1",
	"./building.png": "e78c",
	"./collector.png": "50a8",
	"./command.png": "953f",
	"./google.png": "bdf9",
	"./linux.png": "ff04",
	"./organization.png": "b682",
	"./settings.png": "670d",
	"./slack.png": "4954",
	"./window.png": "d95b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dc9";